var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leaflet-maps-page"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"flex md12 xs12"},[_c('va-card',{staticClass:"leaflet-maps-page__widget",attrs:{"title":"Leaflet Maps"}},[_c('leaflet-map',{staticStyle:{"height":"65vh"}})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }